import React from "react"
import { Checkbox, Divider, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select, Stack, Tooltip, Typography } from "@mui/material";
import { Arrayify } from "../../Functions/utils";
import { Input_SwitchN } from "./Input_SwitchN";
import { set } from "lodash";
import { defaultColor, offColor, onColor } from "../../App/GridRenderers";


export const InputSelect1 = ({ label, name, value, onChange, minWidth = 220, maxWidth = 300, errors = [], avail, tooltip, ...others }) => {
    const isDivider = (s) => {
        return s === "--Divider--"
    }
    return (
        <Tooltip title={tooltip} arrow placement="top">
            <FormControl size="small" sx={{ minWidth: minWidth, maxWidth: maxWidth }}
                error={!!errors[name]}>
                <InputLabel id={name}>{label}</InputLabel>
                <Select
                    labelId={name}
                    label={label}
                    value={value}
                    onChange={onChange}
                    name={name}
                    {...others}            >
                    {Arrayify(avail).map((v, index) => (
                        isDivider(v) ? (<Divider />) : (
                            <MenuItem size="small" value={v}>
                                {v}
                            </MenuItem>
                        )))}
                </Select>
                {!!errors[name] && (
                    <FormHelperText error={!!errors[name]}>
                        {errors[name]}
                    </FormHelperText>
                )}
            </FormControl>
        </Tooltip>
    )
}


export const InputSelect1ES = ({ label, name, value, onChange, minWidth, maxWidth, errors = [], avail, ...others }) => {

    const itemReplacer = (array, oldItem, newItem) => {
        return Arrayify(array).map(item => item === oldItem ? newItem : item);
    }

    const emptySelect = "--none--*";

    const emptySelectReplacer = (set) => {
        return itemReplacer(set, "", emptySelect)
    }

    const emptySelectDisplay = (v) => {
        // if we swap the avail, then the item may not be in it anymore (annuity does this)
        if (!Arrayify(avail).includes(value)) {
            onChange({
                target:
                {
                    name: name,
                    value: ""
                }
            })
        }
        return (v === "" ? emptySelect : v)
    }

    const emptySelectStore = (v) => {
        let x = v === emptySelect ? "" : v
        return x
    }


    const onChange_t = (e) => {
        let v = emptySelectStore(e.target.value)
        e.target.value = v

        onChange(e);
    };



    return (
        <InputSelect1
            label={label}
            name={name}
            value={emptySelectDisplay(value)}
            onChange={onChange_t}
            minWidth={minWidth}
            maxWidth={maxWidth}
            errors={errors}
            avail={emptySelectReplacer(avail)}
            {...others}
        />
    )

}

// not much of a convenience, but why not
export const InputSelectMonth = ({ minWidth = 115, maxWidth = 115, ...others }) => {
    const months = [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ]
    return (
        <InputSelect1ES
            avail={months}
            minWidth={minWidth}
            maxWidth={maxWidth}
            {...others}
        />
    )

}

export const InputSelectN = ({ label, name, value, onChange, minWidth, maxWidth, errors, avail, ...others }) => {
    return (
        <FormControl size="small" sx={{ minWidth: minWidth, maxWidth: maxWidth }}
            error={!!errors[name]}>
            <InputLabel id={name}>{label}</InputLabel>
            <Select
                labelId={name}
                label={label}
                value={Arrayify(value)}
                onChange={onChange}
                name={name}
                multiple
                renderValue={(selected) => selected.join(", ")}
                {...others}            >
                {
                    Arrayify(avail).map((v, index) => (
                        <MenuItem key={v} value={v}>
                            <Checkbox sx={{ py: 0, px: 1 }} size="small" checked={value !== undefined && value.indexOf(v) > -1} />
                            <ListItemText primary={v} />
                        </MenuItem>
                    ))}
            </Select>
            {!!errors[name] && (
                <FormHelperText error={!!errors[name]}>
                    {errors[name]}
                </FormHelperText>
            )}
        </FormControl>
    )
}

export const InputSelectTriN = ({ label, name, value, onChange, minWidth, maxWidth, errors, avail, onChange_nv, options = ["off", "default", "on"], colors = [offColor, defaultColor, onColor], defaul = "default", ...others }) => {
    const mySwitchChange_nv = (n, v) => {
        let nv = {}
        if (value !== undefined) {
            nv = structuredClone(value);
        }
        if (v === defaul) {
            delete nv[n]
        } else {
            nv = set(nv, n, v)
        }
        onChange_nv(name, nv)
    }

    const myRender = (selected) => {
        let s = "--default--"
        //let s = ""
        if (value !== undefined && Object.keys(value).length > 0) {
            s = "--modified--"
        }
        return s
    }

    return (
        <FormControl size="small" sx={{ minWidth: minWidth, maxWidth: maxWidth }}
            error={!!errors[name]}>
            <InputLabel id={name}>{label}</InputLabel>
            <Select
                labelId={name}
                label={label}
                value={Object.keys(value).length > 0 ? ["modified"] : ["default"]}
                name={name}
                multiple
                renderValue={myRender}
                displayEmpty={true}
                //renderValue={(s) => { console.log(s) }}
                {...others}
            >
                {
                    Arrayify(avail).map((v, index) => (
                        <MenuItem key={v} value={v}
                            onClick={(e) => { e.stopPropagation() }}
                            onMouseDown={(e) => { e.stopPropagation() }}
                        >
                            <Stack direction="row" spacing={6}>
                                <Input_SwitchN
                                    name={v}
                                    value={value === undefined ? defaul :
                                        value[v] === undefined ? defaul :
                                            value[v]}
                                    onChange_nv={(n, v) => mySwitchChange_nv(n, v, index)}
                                    avail={options}
                                    colors={colors}

                                />

                                <ListItemText primary={v} />
                            </Stack>
                        </MenuItem>
                    ))}
            </Select>
            {!!errors[name] && (
                <FormHelperText error={!!errors[name]}>
                    {errors[name]}
                </FormHelperText>
            )}
        </FormControl>
    )
}


export const InputSelectDefOn = ({ ...others }) => {
    // console.log({ ...others })

    return (
        <InputSelectTriN
            options={["default", "on"]}
            colors={[defaultColor, onColor]}
            defaul="default"
            {...others}
        />
    )


}

export const InputSelectOffDef = ({ ...others }) => {
    // console.log({ ...others })

    return (
        <InputSelectTriN
            options={["off", "default"]}
            colors={[offColor, defaultColor]}
            defaul="default"
            {...others}
        />
    )


}